module.exports = __webpack_public_path__ + "img/install-wg.de7483d5.png";